import{observer,ComponentView,Preact,h,state,action,Link,Utils,Router} from "@websites/website_compiler/Client";
import * as Routes from "./gen/routes";
import * as Stores from "./stores/ui";



if(document){

    console.log("(process.env.ENV",process.env.ENV);

    if(false){
        Utils.DevEnableAutoLoad();
    }
    
    const appEl = document.body;
    const routerProps = (document as any).routerProps;
    console.log("routerProps",routerProps)
    const cp = <Stores.Ui {...routerProps} routes={Routes}></Stores.Ui>;

    if((document as any).hydrate){
        console.log("renderMode: hydrating")
        Preact.hydrate(cp,appEl);
    }else{
        console.log("renderMode: rendering")

        Preact.render(cp,appEl);
    }

}

